<div class="col-md-8 col-md-offset-1" *ngIf="!bookingInit">
  <div class="loader-container">
    <!-- <div class="loader">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" />
      </svg>
    </div> -->
    <div class="languageSelector"></div>
    <div class="backStep"></div>
    <div class="pageTitle"></div>
    <div class="pageSubTitle"></div>
    <div class="pageTabs"></div>
    <div class="pageSearch"></div>
    <div class="pageManualAddress"></div>
  </div>
</div>

<!-- NEW METHOD CHANGE IN ZOOM AND VIEWCONTROL ZOOM Angular 10-->
<!-- <agm-map *ngIf="(selectedLocationType === 4) && residentialGeoCoords" class="map-location map-location--full"
  [disableDefaultUI]="false" [scrollwheel]="false" [latitude]="residentialGeoCoords.latitude"
  [longitude]="residentialGeoCoords.longitude" [zoom]="16" [maxZoom]="16" [minZoom]="16" [disableDefaultUI]="true"
  [styles]="mapStyles">
  <agm-marker [latitude]="residentialGeoCoords.latitude" [longitude]="residentialGeoCoords.longitude"
    iconUrl="https://portrlivecdnstorage.blob.core.windows.net/webimages/location.png">
  </agm-marker>
</agm-map> -->

<div *ngIf="(selectedLocationType === 4) && residentialGeoCoords" id="residentialMap" style="width: 100%;"></div>

<section class="col-md-8 col-md-offset-1 fadeInUp" *ngIf="bookingInit">

  <app-language-selector></app-language-selector>

  <button id="collection-back" type="button"
    class="btn btn-link hidden-sm hidden-xs back-btn" *ngIf="bookingType !== 'amend'" (click)="goPanelBack()">
    <i class="icon">chevron_left</i>{{appCopy.panelHeader['linkBack'+selectedLanguage]}}
  </button>
  <button type="button" class="btn btn-link back-btn" *ngIf="bookingType === 'amend'" (click)="cancelLocationAmend()">
    <i class="icon">chevron_left</i>{{appCopy.panelHeader['linkCancel'+selectedLanguage]}}
  </button>

  <fieldset>
    <legend class="margin-bottom-24 hidden-xs text-dark-blue">
      <h1 class='h1 margin-bottom-24' *ngIf="flightDirection === 1 && !canBeHubdropBooking" [innerHTML]="appCopy.panelHeader['title'+selectedLanguage].replace('%s', appAirportCopy[flightData.flightStatusDetails[0].departureAirport.airportCode]['airportName'+selectedLanguage])"></h1>
      <h1 class='h1 margin-bottom-24' *ngIf="flightDirection === 1 && canBeHubdropBooking" [innerHTML]="appCopy.panelHeader['title_hubdrop'+selectedLanguage].replace('%s', appAirportCopy[flightData.flightStatusDetails[0].departureAirport.airportCode]['airportName'+selectedLanguage])"></h1>
      <h1 class='h1 margin-bottom-24' *ngIf="flightDirection !== 1" [innerHTML]="appCopy.panelHeader['title'+selectedLanguage].replace('%s', appAirportCopy[flightData.flightStatusDetails[flightData.flightStatusDetails.length
      - 1].arrivalAirport.airportCode]['airportName'+selectedLanguage])"></h1>


      <p>{{ appCopy.panelHeader['content'+selectedLanguage] }}</p>
    </legend>
    <ng-container *ngIf="!bookingState.bookingDetails.flyBack">
      <app-upsell-booking *ngIf="upsellbookingStatus.showUpsellScreen"
      [styledClass]="''" [appCopy]='appCopy' [selectedLanguage]='selectedLanguage'>
    </app-upsell-booking>
    </ng-container>
    <div class=" row" *ngIf="showMenu && !upsellbookingStatus.showUpsellScreen">
      <div class="col-md-7 col-md-offset-5 margin-bottom-24">
        <div class="radio-toggle" style="background-color: #DBE5FD;">
          <div class="active-item-bg" [ngStyle]="{
              'width': 100 / locationItems.length + '%',
              'transform': 'translateX(' + activeRadioIndex * 100 + '%)'
          }"></div>
          <div class="flex-always">
            <div class="radio radio-toggle__item" *ngFor="let item of locationItems; let i = index">
              <input type="radio" name="locationType" ngControl="locationType" [id]="item.type" [value]="item.value"
                [(ngModel)]="selectedLocationType" (ngModelChange)="radioToggleChange(i)" required>
              <label [for]="item.type">{{appCopy.panelHeader['button'+item.type+selectedLanguage]}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>

  <div *ngIf="!upsellbookingStatus.showUpsellScreen">
    <!-- Residential location panel -->
    <app-residential *ngIf="selectedLocationType === 4" [bookingState]="bookingState" [currentBooking]="currentBooking"
      [userAddresses]="userAddresses" [selectedLocationId]="selectedLocationId"
      [appAirportCopy]="appAirportCopy" (goPanelBack)="goPanelBack($event)"
      (callGetLocation)="callGetLocation($event)" (geoPostcode)="getGeocode($event)"
      (selectedGeoCoords)="selectedGeoCoords($event)" (updatePrice)="updatePrice($event)"
      (handleShowMenu)="handleShowMenu($event)" (sendToBooking)="sendToBooking($event)"
      (cancelLocationAmend)="cancelLocationAmend($event)" [appCopy]="appCopy"
      [selectedLanguage]="selectedLanguage" [isSbbSubsidyApplied]="isSbbSubsidyApplied"
      [isSbbSubsidyAvailable]="isSbbSubsidyAvailable"
      [bookingType]="bookingType">
    </app-residential>

    <!-- Hotel location panel -->
    <app-hotel-business *ngIf="selectedLocationType === 2" [bookingState]="bookingState" [currentBooking]="currentBooking"
      [selectedLocationType]="selectedLocationType" [selectedLocationId]="selectedLocationId"
      (callGetLocation)="callGetLocation($event)" (updatePrice)="updatePrice($event)"
      (handleShowMenu)="handleShowMenu($event)" (sendToBooking)="sendToBooking($event)"
      [appAirportCopy]="appAirportCopy" [appCopy]="appCopy" [isSbbSubsidyApplied]="isSbbSubsidyApplied"
      [isSbbSubsidyAvailable]="isSbbSubsidyAvailable"
      [selectedLanguage]="selectedLanguage" [bookingType]="bookingType">
    </app-hotel-business>

    <!-- Airport location panel -->
    <app-airport *ngIf="selectedLocationType === 8" [bookingState]="bookingState" [currentBooking]="currentBooking"
      [airportData]="airportData" (handleShowMenu)="handleShowMenu($event)" (sendToBooking)="sendToBooking($event)"
      [appCopy]="appCopy" [selectedLanguage]="selectedLanguage">
    </app-airport>
  </div>
</section>
